'use strict';

var React = require('react');

var SvgPinMinor = function SvgPinMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.792 3.275c.367-.21.793-.275 1.208-.275h4c.415 0 .841.065 1.209.275.408.234.668.608.752 1.042.075.388-.005.748-.1 1.012-.09.251-.218.485-.352.686l-.459.872c-.025.058-.04.098-.046.123l.048.109 1.425 2.897c.241.396.432.794.498 1.184.079.462-.016.993-.458 1.372-.348.298-.774.37-1.017.398-.261.03-.548.03-.773.03h-1.727v3a1 1 0 1 1-2 0v-3h-1.727c-.225 0-.511 0-.772-.03-.244-.028-.67-.1-1.018-.398-.442-.38-.537-.91-.458-1.372.066-.39.257-.788.499-1.184l1.421-2.892c.027-.06.041-.092.05-.116a1.03 1.03 0 0 0-.045-.121l-.46-.872a3.21 3.21 0 0 1-.351-.686 1.93 1.93 0 0 1-.1-1.012c.084-.434.344-.808.753-1.042Zm6.204 3.767v-.003Z"
  }));
};

exports.SvgPinMinor = SvgPinMinor;
